import { render } from "./ControlBill.vue?vue&type=template&id=0184b1e8&scoped=true&ts=true"
import script from "./ControlBill.vue?vue&type=script&lang=ts"
export * from "./ControlBill.vue?vue&type=script&lang=ts"

import "./ControlBill.vue?vue&type=style&index=0&id=0184b1e8&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0184b1e8"]])

export default __exports__